import React, {useEffect, useState} from "react";

// UI
import MaterialTable from "@material-table/core";
import _, { reject } from "lodash";

// Table Params
import { OPTIONS, LOCALIZATION, getColumns } from "./Params/KCCWorksitesSurveys";
import { tableIcons } from "../../ui-components/TableIcons";
import TableStyle from "../TableStyle";
import { flattenTintometersData } from "./Params/common";
import Modal from "../../ui-components/Modal";
import Spinner from "../../ui-components/Spinner";


export default function KCCWorksitesSurveysTable({ intl, countryCode, isLoading, colors, datacaller, generateTintometristSurveyCallbackFn, isTintometristServiceSelected }) {

  // state
  const [surveyToDuplicate, setSurveyToDuplicate] = useState(null);
  const [surveyDuplicationLoading, setSurveyDuplicationLoading] = useState(false);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const cols = getColumns(intl, countryCode, colors, setSurveyToDuplicate, isTintometristServiceSelected);
    setColumns(cols);
  }, [intl, countryCode, colors, setSurveyToDuplicate, isTintometristServiceSelected]);

  // FIXME this table throws a warning since it's reloaded two times (one when colors are loaded, the other when surveys
  //  are loaded) having the same rows. We must find a way to resolve this
  return <>
    <TableStyle>
      <MaterialTable
        columns={columns}
        data={(query) => {
          return new Promise(async (resolve, reject) => {
            const data = await datacaller(query, columns);
            const { result: surveys, count } = data;
            const flatData = flattenTintometersData(surveys);
            resolve({
              data: flatData ?? [],
              page: query.page,
              totalCount: count,
            })
        })}}
        icons={tableIcons}
        isLoading={isLoading}
        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
        options={{
          ...OPTIONS,
          pageSizeOptions:[5, 20, 50, 100],
        }}
        localization={LOCALIZATION}
        pagination
      />
    </TableStyle>
    {
      surveyToDuplicate && (
        <Modal
          type="info"
          title={intl.formatMessage({id: 'tintometrist_duplicate_survey_title'})}
          description={intl.formatMessage({id: 'tintometrist_duplicate_survey_description'})}
          onDismiss={() => { setSurveyToDuplicate(null); }}
          onExit={() => { setSurveyToDuplicate(null); }}
          onConfirm={async () => {
            setSurveyDuplicationLoading(true);
            await generateTintometristSurveyCallbackFn(
              surveyToDuplicate,
              () => {
                setSurveyDuplicationLoading(false);
                setSurveyToDuplicate(null);
              }
            );
          }}
          confirmText={
            !surveyDuplicationLoading
              ? intl.formatMessage({id: 'confirm'})
              : <div className="relative w-full h-full"><Spinner /></div>
          }
          dismissText={intl.formatMessage({id: 'cancel'})}
        />
      )
    }
  </>
}
